// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createAdminIndiamart = (client) => ({
    /**
     * `GET /admin/indiamart/leads`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminIndiamartLeadsRetrieve
     * @source packages/medusa-plugin-indiamart-v2/src/api/admin/indiamart/leads/route.ts
     */
    listLeads: (query, headers) => client.fetch("/admin/indiamart/leads", { method: "GET", query, headers }),
    /**
     * `GET /admin/indiamart/sync-status`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminIndiamartSyncStatusRetrieve
     * @source packages/medusa-plugin-indiamart-v2/src/api/admin/indiamart/sync-status/route.ts
     */
    listSyncStatus: (query, headers) => client.fetch("/admin/indiamart/sync-status", { method: "GET", query, headers }),
    /**
     * `GET /admin/indiamart/config`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminIndiamartConfigRetrieve
     * @source packages/medusa-plugin-indiamart-v2/src/api/admin/indiamart/config/route.ts
     */
    retrieveConfig: (query, headers) => client.fetch("/admin/indiamart/config", { method: "GET", query, headers }),
    /**
     * `POST /admin/indiamart/sync`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminIndiamartSyncCreate
     * @source packages/medusa-plugin-indiamart-v2/src/api/admin/indiamart/sync/route.ts
     */
    sync: (body, query, headers) => client.fetch("/admin/indiamart/sync", { method: "POST", body, query, headers }),
    /**
     * `POST /admin/indiamart/config`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminIndiamartConfigCreate
     * @source packages/medusa-plugin-indiamart-v2/src/api/admin/indiamart/config/route.ts
     */
    updateConfig: (body, query, headers) => client.fetch("/admin/indiamart/config", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=indiamart.js.map